import { render, staticRenderFns } from "./StudentActivity.vue?vue&type=template&id=19a3e284&scoped=true"
import script from "./StudentActivity.vue?vue&type=script&lang=js"
export * from "./StudentActivity.vue?vue&type=script&lang=js"
import style0 from "./StudentActivity.vue?vue&type=style&index=0&id=19a3e284&prod&lang=stylus&scoped=true"
import style1 from "./StudentActivity.vue?vue&type=style&index=1&id=19a3e284&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a3e284",
  null
  
)

export default component.exports